import {useState, useEffect, useRef} from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';
import {auth} from './firebaseConfig';
import {endMeeting, hasMeetingEnded} from './organizer_options';

export default function Header({type, thisUser, handleClickLink, sessionId}) {
    const history = useHistory();
    const [endMeetingPopup, setPopup] = useState("d-none");
    const [meetingEnded, setMeetingEnded] = useState(null);
    const mountedRef = useRef(false)
    if(sessionId) hasMeetingEnded(sessionId).then((response) => {
        if(mountedRef.current) setMeetingEnded(response)
    });

    let title = "";
    switch(type){
        case 'admin':
            title = "Admin View";
            break;
        case 'attendee':
            title = "CommunityClick";
            break;
        default: 
            title = "";
    }
    const user = thisUser;
    const handleContinueMeeting= () => {
        if(mountedRef.current) setPopup("d-none");
    }

    const handleEndMeeting = () => {
        if(sessionId) endMeeting(sessionId).then((response) => {
            console.log(`Meeting ${sessionId} ended successfully.`)
            if(mountedRef.current) setPopup("d-none");
        });
    }

    useEffect(() => {
        mountedRef.current = true;
        return () => {mountedRef.current = false;}
    }, [])
    return (
        <>
            <Navbar collapseOnSelect expand="sm" bg="dark" variant="dark" fixed="top" className="px-3 py-1">
                <Navbar.Brand href="" className="d-none d-sm-block">{title}</Navbar.Brand>
                <Nav className="flex-row w-auto">
                        {(type ==="admin") && <Nav.Link href="/admin#" onClick={() => (handleClickLink("/admin"))}><i className="mx-1 fas fa-home nav-icon"></i></Nav.Link>}
                        {(type ==="admin") && <Nav.Link href="/admin#dashboard" onClick={() => (handleClickLink("/admin#dashboard"))}><i className="mx-1 fas fa-tachometer-alt nav-icon"></i></Nav.Link>}
                        {(type ==="admin") && <Nav.Link href="/admin#meetings" onClick={() => (handleClickLink("/admin#meetings"))}><i className="mx-1 fas fa-calendar-alt nav-icon"></i></Nav.Link>}
                </Nav>
                {(type === "admin") && user &&
                    <>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse className="justify-content-end">
                        {sessionId && meetingEnded === false && <Button variant="danger" className="w-sm-100" onClick={() => (setPopup("d-flex"))}>End Meeting</Button>}
                        <Button variant="outline-danger" className="w-sm-100" onClick={() =>{
                                auth.signOut(); 
                                localStorage.removeItem("currentSession");
                                history.push("/");
                                }}>Logout</Button>
                    </Navbar.Collapse>
                    </>
                }
            </Navbar>
            {!meetingEnded && <div className={endMeetingPopup + " bg-dark position-fixed flex-column justify-content-center align-items-center"} style={{zIndex: 5}}>
                <span className="w-sm-100 d-flex flex-column align-items-center">
                    <h4 className="text-center text-warning my-3">Are you sure you want to end this meeting?</h4>
                    <Button variant="primary" className="w-100" onClick={handleContinueMeeting}>No, continue meeting</Button>
                    <Button variant="outline-danger" className="w-100" onClick={handleEndMeeting}>Yes, end meeting</Button>
                </span>
            </div>}
        </>
    )
}
